import { OrderDetail } from '@insurance/api/requests'

import { AdditionalEquipment } from './AdditionalEquipment'
import { CascoInsuranceProvider } from './CascoInsuranceContext'
import { ContractorType } from './ContractorType'
import { InsuranceAmount } from './InsuranceAmount'
import { InsurancePackage } from './InsurancePackage'
import { normalizeOrderData } from './utils'

type Props = { order: OrderDetail }

export const ApproveCascoOrderFields = ({ order }: Props) => {
  return (
    <CascoInsuranceProvider isEditable order={order}>
      <ContractorType />
      <InsurancePackage />
      <InsuranceAmount hiddenCost />
      <AdditionalEquipment />
    </CascoInsuranceProvider>
  )
}

ApproveCascoOrderFields.normalizeOrderData = normalizeOrderData
